<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`media/documents/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">
                    Title *
                  </label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="text" class="col-md-2">Text</label>
                  <div class="col-md-10">
                    <ckeditor id="text" v-model="entity.text" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">File *</label>
                  <div class="col-md-10">
                    <dropzone
                      v-if="dropzoneOptions"
                      id="files-uploader"
                      ref="dropzone"
                      :options="dropzoneOptions"
                      :destroy-dropzone="false"
                      @vdropzone-file-added="fileAdded"
                      @vdropzone-removed-file="fileRemoved"
                    />
                    <div v-else>Dropzone can't work without upload url.</div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Document Files</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.document_files"
                      :default-options="defaultOptions.df"
                      :search-function="docFilesSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Questions and Answers</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.questions_and_answers"
                      :default-options="defaultOptions.qa"
                      :search-function="qaSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-model="entity.date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="author" class="col-md-2">Author</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.author"
                      :default-options="defaultOptions.people"
                      :search-function="peopleSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="author" class="col-md-2">Receiver</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.receiver"
                      :default-options="defaultOptions.people"
                      :search-function="peopleSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Document has changed successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import MultiselectRemote from '@/global/components/MultiselectRemote';
import SelectRemote from '@/global/components/SelectRemote';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import Datepicker from '@/global/components/Datepicker';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
import { uploadStatus } from '@/helpers/constants';
import config from '../../../config';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';

const { SUCCESS } = uploadStatus;

export default {
  name: 'DocumentEdit',

  components: {
    'multiselect-remote': MultiselectRemote,
    'select-remote': SelectRemote,
    'open-on-site': OpenOnSiteButton,
    dropzone: Dropzone,
    referencer: Referencer,
    terms: Terms,
    datepicker: Datepicker,
  },

  mixins: [EditPageMixin, DefaultOptionsRequests, CommonPageMixin],

  data() {
    return {
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 2048,
      },
      saveErrorMessage: '',
      file: null,
      uploadedFile: null,
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'media',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}media/documents/${this.$route.params.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFile() {
      const getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'media_doc');
    },
  },

  watch: {
    uploadingFile: {
      handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          const { dropzone } = this.$refs;
          dropzone.removeAllFiles();
          dropzone.manuallyAddFile(val.file, '/');
          this.uploadedFile = val.file;
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.$_getDefaultDF();
    this.$_getDefaultPeople();
    this.$_getDefaultQa();
  },

  methods: {
    docFilesSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/document-files?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    qaSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}questions-and-answers?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    peopleSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}people?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    manuallyAddFiles() {
      const file = {
        file: {
          name: this.entity.mediaFile.file_name,
          size: this.entity.mediaFile.size,
        },
        url: this.entity.mediaFile.public_url,
        thumb: this.entity.mediaFile.thumbnail,
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.entity.mediaFile.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    fileAdded(file) {
      this.file = file;
    },
    fileRemoved() {
      this.file = null;
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/documents/${this.$route.params.id}`, {
        params: {
          with: [
            'references',
            'mediaFile',
            'terms',
            'path_alias',
            'document_files',
            'author',
            'receiver',
            'questions_and_answers',
            'featured',
          ],
        },
      }).then((response) => {
        this.source = this.$_apadtSource(response.data);
        this.entity = _.cloneDeep(this.source);
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        if (this.entity.mediaFile) setTimeout(this.manuallyAddFiles, 100);
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting document request' });
        console.log('Error in get document query', error);
      });
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('text', this.entity.text ? this.entity.text : '');
      postFormData.append('summary', this.entity.summary ? this.entity.summary : '');
      for (let i = 0; i < this.entity.document_files.length; i += 1) {
        postFormData.append('document_files_ids[]', this.entity.document_files[i].id);
      }
      for (let i = 0; i < this.entity.questions_and_answers.length; i += 1) {
        postFormData.append('questions_and_answers[]', this.entity.questions_and_answers[i].id);
      }
      if (this.entity.date) postFormData.append('date', this.entity.date);
      postFormData.append('author_id', this.entity.author ? this.entity.author.id : '');
      postFormData.append('receiver_id', this.entity.receiver ? this.entity.receiver.id : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}media/documents/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { prefix, host } = this.$config.app_api;
      const { uploadedFile, file } = this;
      const { acceptedFiles } = this.dropzoneOptions;
      const vm = this;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (file && !file.manuallyAdded && uploadedFile !== file) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: this.$route.params.id,
            files: [file],
            token,
            acceptedFiles,
            contentType: response.data.content_type,
          });
          vm.uploadedFile = file;
        }
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in update document query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?1583454e